import React from 'react';

import { IModalProps } from '../../../../Common/Modal';

import { BasicErrorModal } from './Base';

const HEADLINE: string =
  "We weren't able to accept your submission successfully.";
const MESSAGE: string = 'Please attempt to re-submit your document uploads.';

export const UploadFailure: React.FunctionComponent<IModalProps> = ({
  close,
  show
}) => <BasicErrorModal show={show} close={close} headline={HEADLINE} message={MESSAGE} />;
